import { useState } from 'react';
import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';
import BdoSelectInput from './BdoSelectInput';

const BdoSelectInputContainerStyled = styled.div`
  position: relative;
  z-index: 100;

  .select-input-wrapper {
    ${(props) => (props.centerOnMobile ? 'justify-content: center;' : '')}
    ${(props) => (!props.centerOnMobile ? 'padding: 0 10rem 0 1.6rem;' : '')}
    align-items: center;
    display: flex;
    flex: 1 1 100%;
    flex-direction: row;
    margin-bottom: 3rem;
    max-width: 100%;
    z-index: 100;

    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    white-space: nowrap;
    width: 100%;

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }

    @media ${device.desktop} {
      justify-content: flex-start;
      margin-bottom: 0.8rem;
      padding: 0 7rem;
      position: relative;
      overflow-x: visible;
      white-space: normal;
    }

    label {
      line-height: 2.4rem;
      margin-right: 0.8rem;
      padding: 0;

      @media ${device.desktop} {
        padding: 0.8rem 0 1.6rem 0;
      }
    }
  }
`;

const BdoSelectInputContainer = (props) => {
  const { filterLabel, filters, className } = props;
  const [openFilter, setOpenFilter] = useState(null);

  const multiSiblingFilterClicked = (index) => {
    setOpenFilter(index);
  };

  return (
    <BdoSelectInputContainerStyled className={className} centerOnMobile={filters.length === 1}>
      <div className="select-input-wrapper">
        <label id="filter-label">{filterLabel}</label>
        {filters.map((filterArray, index) => (
          <BdoSelectInput
            key={filterArray.filterOptions[0]}
            {...(filters.length > 1 && {
              multiSiblingFilterClicked,
              isSiblingInputOpen: !(openFilter === index || openFilter === null)
            })}
            onChange={filterArray.onChange}
            isMultiSiblingFilter={filters.length > 1}
            ariaLabelledBy="filter-label"
            optionsList={filterArray.filterOptions}
            inputIndex={index}
            updatedValueFromParent={props.updatedValueFromParent}
            preselectedOption={filterArray.preselectedOption ? filterArray.preselectedOption : 0}
          />
        ))}
      </div>
    </BdoSelectInputContainerStyled>
  );
};

export default BdoSelectInputContainer;
